export default {
    methods: {
        errorApi: function(err, callback) {
            let alertMsg = '';
            let defalutCase = true;
            let errorId = err?.id != null ? err?.id : err?.code;

            if (errorId) {
                switch (errorId) {
                    case 401:
                        alertMsg = err.message;
                        break;
                    case 412:
                        alertMsg = "Token invalid";
                        defalutCase = false;
                        break;
                    default:
                        alertMsg = err.message;
                        break;
                }
            } else {
                alertMsg = "Network connection error!";
            }

            if (typeof callback == 'function' && !defalutCase) {
                callback(err);
            }

            if (this.modal.alertModal != null) {
                this.modal.alertModal
                    .clearModal()
                    .setMsg(alertMsg)
                    .show();
            }
        },
    }
}
